import React          from 'react';
import Menu           from './menu';
import Numbers        from './numbers';
import Raffle         from './raffle';
import Exercises      from './exercises';
import General        from './general';

import box_0          from '../images/box_0.png';
import box_1          from '../images/box_1.png';
import box_2          from '../images/box_2.png';
import box_3          from '../images/box_3.png';
import box_4          from '../images/box_4.png';
import box_5          from '../images/box_5.png';
import box_6          from '../images/box_6.png';
import box_7          from '../images/box_7.png';
import box_8          from '../images/box_8.png';
import box_9          from '../images/box_9.png';
import box_10         from '../images/box_10.png';

import exercisesIcon  from '../images/exercisesIcon.png';
import generalIcon    from '../images/generalIcon.png';
import numbersIcon    from '../images/numbersIcon.png';
import raffleIcon     from '../images/raffleIcon.png';

import NavButton      from '../components/NavButton';
import { makeStyles } from '@material-ui/core/styles';


const numbers   = 'התאמת מספר לתבנית ולהיפך';
const exercises = 'פתרון בעזרת התבניות';
const raffle    = 'התאמת תרגיל לתבניות';
const general   = 'משלכם';

const boxes = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, box_10]
const pages = [
  { name: general,   icon: generalIcon },
  { name: raffle,    icon: raffleIcon },
  { name: exercises, icon: exercisesIcon },
  { name: numbers,   icon: numbersIcon }
]

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.8s',
    }
}))

const Root: React.FC = () => {

  const classes = useStyles();

  const [size, setSize] = React.useState([0,0]);
  
  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const [page, setPage]               = React.useState('menu')
  const [pageOpacity, setPageOpacity] = React.useState(1);

  const wideScreen = React.useMemo(() => {
    return size[0] > 650
  },[size])

  const handleNavigate = (val: string) => {
    setPageOpacity(0)
    setTimeout(() => {
      setPage(val)
      setPageOpacity(1)
    },800)     
  } 

  const reloadRaffle = () => {
    setPageOpacity(0)
    setTimeout(() => {
      setPage('')
      setPageOpacity(1)
    },400)
    setTimeout(() => {
      setPage(pages[2].name)
      setPageOpacity(1)
    },800)    
  }

  return (
     <div 
        className = { classes.root }
        style     = {{
            opacity: pageOpacity
        }}
     >
        {
            page === 'menu'    && <Menu wideScreen = { wideScreen } pages = { pages } handleNavigate = { handleNavigate } />
        }
        {
            page === numbers   && <Numbers wideScreen = { wideScreen } handleNavigate = { handleNavigate } size = { size }/>
        }
        {
            page === exercises && <Exercises wideScreen = { wideScreen } handleNavigate = { handleNavigate } size = { size }/>
        }
        {
            page === raffle    && <Raffle wideScreen = { wideScreen } handleNavigate = { handleNavigate } size = { size } reloadRaffle = { reloadRaffle }/>
        }
        {
            page === general   && <General  wideScreen = { wideScreen } handleNavigate = { handleNavigate } size = { size }/>
        }
        {
            page !== 'menu'    && <NavButton handleNavigate = { handleNavigate }/>
        }
        {
           boxes.map((val, ind) => {
             return(
               <div
                  key = { `boximg***${ ind }` }
                  style = {{
                    width:           1,
                    height:          1,
                    backgroundImage: `url(${ val })`,
                    position:        'fixed',
                    top:             -999,
                    left:            -999
                  }}
               />
             )
           })
        }
     </div>
  );
}



export default Root;


